<template>
  <div class="bg-white p-4 m-2">
    <h2>Ops!</h2>
    <h6>Criação de novas ações devem ser feitas na nova versão da INDECX</h6>
    <br>
    <button @click="getV3()" class="btn btn-primary">Ir para nova versão </button>
  </div>
  <!-- <div class="bg-white p-4 m-2">
    <h1 class="metric-title mb-4">
      {{ $t('newAction.selectMetric.pageTitle') }}
    </h1>
    <metric-types
      metricType="NPS"
      :title="$t('newAction.selectMetric.nps.title')"
      :text="$t('newAction.selectMetric.nps.description')"
      :btnDisabled="true"
      image="NPS.png"
    />
    <metric-types
      metricType="CES"
      :title="$t('newAction.selectMetric.ces.title')"
      :text="$t('newAction.selectMetric.ces.description')"
      :btnDisabled="true"
      image="ces.png"
    />
    <metric-types
      metricType="CSAT"
      :title="$t('newAction.selectMetric.csat.title')"
      :text="$t('newAction.selectMetric.csat.description')"
      :btnDisabled="true"
      image="ces.png"
    />
    <metric-types
      metricType="Likert"
      :title="$t('newAction.selectMetric.likert.title')"
      :text="$t('newAction.selectMetric.likert.description')"
      :btnDisabled="false"
      image="likert.png"
    />
    <metric-types
      metricType="Reviews"
      :title="$t('newAction.selectMetric.reviews.title')"
      :text="$t('newAction.selectMetric.reviews.description')"
      :btnDisabled="true"
      image="5stars.png"
    />
    <metric-types
      metricType="Like/Dislike"
      :title="$t('newAction.selectMetric.likeDislike.title')"
      :text="$t('newAction.selectMetric.likeDislike.description')"
      :btnDisabled="true"
      image="like-dislike.png"
    />
  </div> -->
</template>

<script>
import MetricTypes from '../../../molecules/metric-types';

export default {
  components: { MetricTypes },
  methods: {
    getV3() {
      const userAuth = JSON.parse(localStorage.getItem('_indecx'));
      const token = userAuth.token;
      const host = window.location.host;
      const url = (host.includes('indecx.pe')) ? `https://stg.app-indecx.com/redirect/${token}` : `https://v3.app-indecx.com/redirect/${token}`;
      window.location.href = url;
    },
  }
};
</script>

<style>
.metric-title {
  text-transform: uppercase;
  font-weight: bold;
  padding: 0 10px;
  font-size: 21px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/actions/select-metric/index.vue